import React from 'react'
import { Container } from '@mantine/core'
import FooterMain from 'components/UI/FooterMain/FooterMain'
import FormPatientInformedConsent from 'components/UI/Forms/FormPatientInformedConsent/FormPatientInformedConsent'
import HeaderMain from 'components/UI/Headers/HeaderMain/HeaderMain'
import HeaderPage from 'components/UI/Headers/HeaderPage/HeaderPage'
import PageLoader from 'components/UI/PageLoader/PageLoader'
import styles from './styles.module.scss'

const PatientInformedConsent = ({ pageData, projectAuthNumber, instanceCountryCode }) => {
    if (!pageData) return <PageLoader />

    const {
        data,
        referencedProducts,
        referencedTherapeuticIndications,
    } = pageData

    return (
        <div className={styles.container}>
            <div className={styles.layout}>
                <HeaderMain />
                <main>
                    <HeaderPage
                        title={data.title}
                        summary={data.summary}
                        theme='themeLightChocolateWash'
                    />
                    <Container size='1280px' px={0} py='2x'>
                        <FormPatientInformedConsent
                            referencedProducts={referencedProducts}
                            referencedTherapeuticIndications={
                                referencedTherapeuticIndications
                            }
                        />
                    </Container>
                </main>
                <FooterMain />
            </div>
        </div>
    )
}

export default PatientInformedConsent
